/** Scales a box to fit within `max` on its long edge, never upscaling; at least 1×1. */
export function fitWithin(width: number, height: number, max: number): {width: number; height: number; scale: number} {
    const scale = Math.min(1, max / Math.max(width, height, 1));
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
        scale
    };
}
